import type { DealPromptAudienceDealFormValues } from './types.ts';

export const getDefaultDealPromptAudienceDealFormValues = (
  isExplicitNonUsRegion = false
): DealPromptAudienceDealFormValues => ({
  name: '',
  export_targets: {
    cookie: true,
    ctv: false,
    device: true,
    id5: true,
    idl: true,
    ip: isExplicitNonUsRegion,
  },
});
